import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { List, Map, Record } from 'immutable';
import { Action, ActionFactoryFromJS, IAction } from './actions';
import { Condition, ConditionFactoryFromJS, ICondition } from './ICondition';
import {
	INodeLocation,
	NodeLocation,
	NodeLocationFactory,
	NodeLocationFactoryFromJS
} from './INodeLocation';
import { IRuleFlow, RuleFlow, RuleFlowFactoryFromJS } from './IRuleFlow';
interface IBaseRule {
	id: string;
	name: string;
	enabled: boolean;
	orderNo: number;
}
export interface IRule extends IBaseRule {
	conditions: IDictionary<ICondition>;
	actionGroups: IDictionary<Array<string>>;
	actions: IDictionary<IAction>;
	ruleFlows: IDictionary<IRuleFlow>;
	triggerEvents: Array<string>;
	loc: INodeLocation;
}

export interface ReadOnlyRule extends IBaseRule {
	conditions: Map<string, Condition>;
	actionGroups: Map<string, List<string>>;
	actions: Map<string, Action>;
	ruleFlows: Map<string, RuleFlow>;
	triggerEvents: List<string>;
	loc: NodeLocation;
}

export type Rule = ReadonlyRecord<ReadOnlyRule>;

export const RuleFactory = Record<ReadOnlyRule>({
	id: null,
	name: null,
	enabled: true,
	orderNo: 0,
	actionGroups: Map(),
	conditions: Map(),
	actions: Map(),
	ruleFlows: Map(),
	triggerEvents: List(),
	loc: NodeLocationFactory()
});

export const RuleFactoryFromJS = (data: IRule) => {
	const actionGroups: IDictionary<List<string>> = Object.keys(data.actionGroups).reduce(function (
		previous: IDictionary<List<string>>,
		current
	) {
		previous[current] = List(data.actionGroups[current]);
		return previous;
	}, {});

	const conditions: IDictionary<Condition> = Object.keys(data.conditions).reduce(function (
		previous: IDictionary<Condition>,
		current
	) {
		previous[current] = ConditionFactoryFromJS(data.conditions[current]);
		return previous;
	}, {});

	const actions: IDictionary<Action> = Object.keys(data.actions).reduce(function (
		previous: IDictionary<Action>,
		current
	) {
		previous[current] = ActionFactoryFromJS(data.actions[current]);
		return previous;
	}, {});

	const ruleFlows: IDictionary<RuleFlow> = Object.keys(data.ruleFlows).reduce(function (
		previous: IDictionary<RuleFlow>,
		current
	) {
		previous[current] = RuleFlowFactoryFromJS(data.ruleFlows[current]);
		return previous;
	}, {});

	return RuleFactory({
		id: data.id,
		name: data.name,
		enabled: data.enabled,
		orderNo: data.orderNo,
		conditions: Map(conditions),
		actionGroups: Map(actionGroups),
		actions: Map(actions),
		ruleFlows: Map(ruleFlows),
		triggerEvents: List(data.triggerEvents),
		loc: NodeLocationFactoryFromJS(data.loc)
	});
};
